module.exports = __webpack_public_path__ + "static/media/bottom_spain.753bf560.svg";